<script setup lang="ts">
import LeftSideBar from "./components/LeftSideBar.vue";
import BuyVIPDialogues from "@/components/Dialogues/BuyVIPDialogues.vue";
import UserServiceDialogue from "@/components/Dialogues/UserServiceDialogue.vue";
import LogoutDialogues from "@/components/Dialogues/LogoutDialogues.vue";
import ChatBase from "@/components/Dialogues/Chat/ChatBase.vue";
import LoginDialogue from "@/components/Dialogues/LoginDialogue.vue";
import EditChatTitleDialogue from "@/components/Dialogues/EditChatTitleDialogue.vue";
import DeleteChatHistoryDialogue from "@/components/Dialogues/DeleteChatHistoryDialogue.vue";

import { isExpand } from "@/views/Home/useData/useHomePage";
import { ref, watch, computed } from "vue";
import { getDeviceWidth } from "@/utils/device";
import { isCompactMode } from "@/data/pubilc";
import LeftSideBarDrawer from "@/views/Home/components/LeftSideBarDrawer.vue";
import CustomPopup from "@/components/custom-popup/customPopup.vue";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import {
  init,
  dialogueStatus,
  dialogueList,
} from "@/views/Home/useData/module/dialogue";
import { bindDialogue } from "@/views/Home/useData/module/chat";
import { ElMessage } from "element-plus";
import { initChat } from "@/views/Home/useData/module/chat";
import { resetInputBar } from "@/components/Dialogues/useData/useInputBar";

const { isLogin } = storeToRefs(publicStore());

const deviceWidth = getDeviceWidth();

bindDialogue("dialogueStatus", dialogueStatus);
bindDialogue("dialogueList", dialogueList);

watch(deviceWidth, () => {
  const newWidth = deviceWidth.value;
  isCompactMode.value = newWidth <= 680;
  if (newWidth > 1000) {
    isExpand.value = true;
  } else if (newWidth <= 1000) {
    isExpand.value = false;
  }
});

watch(
  isLogin,
  () => {
    if (isLogin.value) {
      setTimeout(() => {
        init();
      }, 1000);
    }
  },
  {
    immediate: true,
  }
);

const sessionId = computed(() => {
  return dialogueStatus.sessionId;
});

watch(
  sessionId,
  (nVal) => {
    const curDialogue = dialogueList.find((dialogue) => {
      const sid = (dialogue as any).session_id;
      return sid === nVal;
    });
    console.log("watch sessionId ", sessionId);
    console.log("curDialogue", curDialogue);
    initChat(sessionId.value, curDialogue);

    //重制对话框
    resetInputBar();
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <el-container class="page-base">
    <el-main class="p0">
      <div class="content">
        <LeftSideBar v-if="!isCompactMode" />
        <ChatBase />
      </div>
    </el-main>
    <BuyVIPDialogues />
    <UserServiceDialogue />
    <LogoutDialogues />
    <LoginDialogue />
    <EditChatTitleDialogue />
    <DeleteChatHistoryDialogue />
    <LeftSideBarDrawer v-if="isCompactMode" />
    <CustomPopup />
  </el-container>
</template>

<style lang="scss" scoped>
.page-base {
  padding: 0;
  width: 100%;
  height: 100%;
}

.p0 {
  padding: 0;
}

.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}
</style>
